import moneyInput from "./moneyInput.vue";

export default moneyInput;
